module.exports = __webpack_public_path__ + "img/pbtm3.e9a73543.png";